import { TypedDocumentNode, gql } from '@apollo/client';

import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { EarlyAccessSpecialOfferBannerContent } from 'components/market/EarlyAccessSpecialOfferBannerContent';

import { EarlyAccessSpecialOfferBanner_anyCard } from './__generated__/index.graphql';
import { useGetCardSpecialEventConfig } from './useGetCardSpecialEventConfig';

export const EarlyAccessSpecialOfferBanner = ({
  card,
}: {
  card: EarlyAccessSpecialOfferBanner_anyCard;
}) => {
  const {
    flags: { useEnableEarlyAccessFlows },
  } = useFeatureFlags();
  const event = useGetCardSpecialEventConfig({ card });
  if (!useEnableEarlyAccessFlows || !card.blueprint) return null;

  return (
    <EarlyAccessSpecialOfferBannerContent
      event={event}
      rarity={card.rarityTyped}
    />
  );
};

EarlyAccessSpecialOfferBanner.fragments = {
  anyCard: gql`
    fragment EarlyAccessSpecialOfferBanner_anyCard on AnyCardInterface {
      slug
      rarityTyped
      blueprint {
        id
      }
      ...useGetCardSpecialEventConfig_anyCard
    }
    ${useGetCardSpecialEventConfig.fragments.anyCard}
  ` as TypedDocumentNode<EarlyAccessSpecialOfferBanner_anyCard>,
};

export default EarlyAccessSpecialOfferBanner;
